import local_store from "store";

export default (user) => {
    local_store.set('user', user);
}
